<template>
    <div class="container">
        <div class="title-container">
            <span>
                {{ $t('administratif.navigation.equipements.header') }}
                <ReglePastille cle="equipements.definition" />
            </span>
        </div>
        <div class="content-container">
            <StepOne v-if="step === 1" :title="$t('administratif.navigation.equipements.search')" @next="next" />
            <StepThree v-if="step === 2" :display-radio="false" :open-info-equipement="true" />
        </div>
    </div>
    <BottomNavigation
        :back="back"
        :cancel="cancel"
        :confirmButtonDisabled="!isValid"
        :first="step === 1"
        :last="step === 2"
        :next="next"
        :no-validation="true"
    />
</template>

<script lang="ts">
import StepOne from '../../Intervention/components/StepOne.vue';
import { defineComponent } from 'vue';
import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import BottomNavigation from '@/components/layout/BottomNavigation.vue';
import { Site } from '@/models/Site';
import StepThree from '../../Intervention/components/StepThree.vue';
import { EQUIPEMENT, INTERVENTION } from '@/modules/Intervention/store/mutation-types';
import { SITE_LIST } from '@/modules/SiteList/store/mutation-types';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'RechercheEquipement',
    components: {
        BottomNavigation,
        StepOne,
        StepThree,
        ReglePastille,
    },
    methods: {
        cancel() {
            this.$router.back();
        },
        next() {
            this.$store.commit(INTERVENTION.SET_STEP, this.step + 1);
        },
        back() {
            this.$store.commit(INTERVENTION.SET_STEP, this.step - 1);
        },
        reset() {
            this.$store.commit(`siteList/${SITE_LIST.RESET}`);
            this.$store.commit(`siteList/${SITE_LIST.SET_FILTER}`, '');
            this.$store.commit(`equipementModule/${EQUIPEMENT.SET_EQUIPEMENT_FILTER}`, '');
            this.$store.commit(`equipementModule/${EQUIPEMENT.SET_ITEMS}`, []);
            this.$store.commit(INTERVENTION.RESET_INTERVENTION);
            this.$store.state.demandeInterventionModuleState.documents = [];
        },
    },
    computed: {
        selectedSite(): Site {
            return this.$store.getters.getInterventionSiteValue;
        },
        selectedEquipement(): Site {
            return this.$store.getters.getInterventionEquipementValue;
        },
        step: {
            get(): number {
                return this.$store.getters.getInterventionStep;
            },
            set(step: number) {
                if (step < this.step) {
                    this.$store.commit(INTERVENTION.RESET_TO_STEP, step);
                } else {
                    this.$store.commit(INTERVENTION.SET_STEP, step);
                }
            },
        },
        isValid() {
            return this.$store.getters.isInterventionFormValid;
        },
    },

    beforeRouteLeave(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
        this.reset();
        next();
    },
    mounted() {
        const query = this.$route.query;
        if (query.groupe || query.sousGroupe || query.siteId || query.rechercheEquipement) {
            if (query.groupe) {
                this.$store.commit(`equipementModule/${EQUIPEMENT.SET_GROUPE_FILTER}`, query.groupe);
            }
            if (query.sousGroupe) {
                this.$store.commit(`equipementModule/${EQUIPEMENT.SET_SS_GROUPE_FILTER}`, query.sousGroupe);
            }
            if (query.rechercheEquipement) {
                this.$store.commit(`equipementModule/${EQUIPEMENT.SET_EQUIPEMENT_FILTER}`, query.rechercheEquipement);
            }
            if (query.siteId) {
                const siteId = parseInt(query.siteId as string);
                if (!isNaN(siteId)) {
                    this.$store.commit(INTERVENTION.SET_SITE, { id: siteId } as Site);
                    this.$store.commit(INTERVENTION.SET_STEP, 2);
                }
            } else {
                this.$store.commit(INTERVENTION.SET_STEP, 2);
            }
            this.$router.replace({ query: {} });
        }
    },
});
</script>

<style scoped>
:deep(.step-one-container) {
    max-height: calc(100vh - 210px);
}
:deep(.step-three-container) {
    max-height: calc(100vh - 210px);
    height: unset;
}
:deep(.equipement-list) {
    max-height: calc(100vh - 305px);
}
.container {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 16px 24px;
}
.content-container {
    margin-top: 8px;
    max-height: 89%;
}
.title-container {
    color: var(--color-principal);
    font-size: var(--font-size-large);
    font-family: 'Raleway Semi Bold', sans-serif !important;
    font-variant-numeric: lining-nums;
    margin-bottom: 8px;
}
:deep(.equipement-list) {
    max-height: calc(100vh - 400px);
}
</style>
